import { render, staticRenderFns } from "./baiduLiveRooms.vue?vue&type=template&id=7abdf728"
import script from "./baiduLiveRooms.vue?vue&type=script&lang=js"
export * from "./baiduLiveRooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports